import {Model} from './Model';

export class FieldCell extends Model {
  public selectedByPlayer: string;
  public colorOfPlayer: string;
}
